import { z } from 'zod';

/** A flag do feature-flag-service (`currentFeatures(system: USER_APP)`) que libera o VOLL
 *  Intelligence para o viajante: a MESMA que o app host lê para armar o takeover de
 *  `/intelligence` (`VollIntelligenceChatModuleSettings`, `voll_users_app`). O customer-api
 *  repassa só as listadas em `LEGACY_FEATURE_FLAGS`. */
export const INTELLIGENCE_CHAT_FEATURE_FLAGS = ['use_intelligence_chat'] as const;

/** `GET /me/intelligence` (BFF ↔ web-chat): o produto liberado para o viajante. Só sai quando
 *  se SABE — flags lidas (`enabled` pela flag) ou viajante sem empresa (`false`); leitura que
 *  falhou é um não-ok, e o web-chat trata como não liberado (fail-closed, #7155). Rota própria,
 *  fora do `/me`: o `AppProfileSchema` é estrito, e a flag já ligada faria a chave nova
 *  quebrar o `/me` inteiro dos bundles antigos. */
export const IntelligenceAccessResponseSchema = z.object({ enabled: z.boolean() }).strict();
export type IntelligenceAccessResponse = z.infer<typeof IntelligenceAccessResponseSchema>;

/** Liberado = todas as flags presentes; `null` (viajante sem empresa) não libera. */
export function intelligenceEnabled(featureFlags: readonly string[] | null): boolean {
  if (featureFlags === null) return false;
  return INTELLIGENCE_CHAT_FEATURE_FLAGS.every((flag) => featureFlags.includes(flag));
}

/** A flag do feature-flag-service que tira do viajante a volta ao app clássico ("App
 *  (Clássico)" na troca de ambiente e no menu do avatar). Ligada = bloqueia; ausente = a volta
 *  segue como sempre, sem precisar ligar para todo mundo. */
export const CLASSIC_EXIT_BLOCK_FEATURE_FLAGS = ['block_classic_app_exit'] as const;

/** `GET /me/classic-exit` (BFF ↔ web-chat): se a volta ao app clássico está bloqueada. Rota
 *  própria pelo mesmo motivo do `/me/intelligence`: os schemas estritos dos bundles antigos. Só
 *  sai quando se SABE; leitura que falhou é um não-ok, e o web-chat mantém a volta (fail-open:
 *  na dúvida o viajante não fica preso no Intelligence). */
export const ClassicExitResponseSchema = z.object({ blocked: z.boolean() }).strict();
export type ClassicExitResponse = z.infer<typeof ClassicExitResponseSchema>;

/** Bloqueada = todas as flags presentes; `null` (viajante sem empresa) não bloqueia. */
export function classicExitBlocked(featureFlags: readonly string[] | null): boolean {
  if (featureFlags === null) return false;
  return CLASSIC_EXIT_BLOCK_FEATURE_FLAGS.every((flag) => featureFlags.includes(flag));
}
